var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "system-container" }, [
    _c(
      "div",
      { staticClass: "system-inner" },
      [
        _c(
          "div",
          { staticClass: "card-wrap" },
          _vm._l(_vm.list, function (item, index) {
            return _c(
              "el-card",
              {
                key: index,
                staticClass: "system-item",
                class: { active: item.appIdentification === _vm.systemId },
                attrs: { shadow: "hover" },
                nativeOn: {
                  click: function ($event) {
                    return _vm.handleCheckSystem(item)
                  },
                },
              },
              [_vm._v("\n        " + _vm._s(item.systemName) + "\n      ")]
            )
          }),
          1
        ),
        _vm._v(" "),
        _c(
          "el-button",
          {
            staticClass: "next-btn",
            attrs: { loading: _vm.loading, size: "small", type: "primary" },
            nativeOn: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.handleGetMenu($event)
              },
            },
          },
          [_vm._v("\n      " + _vm._s(_vm.$t("login.logIn")) + "\n    ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }